import React from "react";

interface PdfIconProps {
  className?: string;
}

export function PdfIcon({ className = "w-5 h-5" }: PdfIconProps) {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Add your PDF SVG code here */}
      <rect x="4" y="2" width="16" height="20" rx="2" fill="#E74C3C" />
      <text x="12" y="15" fontSize="7" fill="white" textAnchor="middle" fontWeight="bold">
        PDF
      </text>
    </svg>
  );
}
